import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle2, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../components/Button';
import { ProtectedLayout } from '../components/ProtectedLayout';
import { PillarConfig } from '../types/alignment';

export function AlignmentAuditComplete() {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedArea, action } = location.state || {};

  if (!selectedArea) {
    navigate('/alignment-audit/start');
    return null;
  }

  return (
    <ProtectedLayout>
      <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 py-12 px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-teal-600 rounded-full mb-4 animate-bounce">
              <CheckCircle2 className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Alignment Action Created
            </h1>
            <p className="text-xl text-gray-700">
              Your {(selectedArea as PillarConfig).name} system is ready for transformation.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Your Next Step</h2>
            <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-lg">
              <p className="text-lg text-gray-800 font-medium">{action}</p>
            </div>
            <p className="text-gray-600 mt-4">
              This action has been added to your task list. Taking this values-based action will begin aligning your {(selectedArea as PillarConfig).name} with your values.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
              <Calendar className="w-6 h-6 text-teal-600" />
              Optional: Schedule a Systems Alignment Call
            </h2>
            <p className="text-gray-700 mb-6">
              Want expert guidance on your alignment journey? Schedule a free 30-minute Systems Alignment Call
              to discuss your audit results and get personalized strategies for your {(selectedArea as PillarConfig).name} system.
            </p>

            <div className="border rounded-lg overflow-hidden">
              <iframe
                src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ1VCrUFLaHH5qwxUhRUFjEW9XjqI5lzG3G9pKO6CZ-aL1gZ9rGJ5QhZKQZg5ZrGaL1g?gv=true"
                style={{ border: 0 }}
                width="100%"
                height="600"
                frameBorder="0"
                title="Schedule Alignment Call"
              />
            </div>

            <p className="text-sm text-gray-500 mt-4 text-center">
              Scheduling is completely optional. You can skip this and continue in the app.
            </p>
          </div>

          <div className="flex justify-center gap-4">
            <Button
              onClick={() => navigate('/dashgrowthloop')}
              className="px-8 py-4 text-lg"
            >
              Continue in App
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </ProtectedLayout>
  );
}
